import store from '@/store'
import _ from 'lodash'

import attributeService from '@/services/akeneo/attribute'
import measures from '@/common/utils/measures'

export function isValidEmail(email) {
    var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(email);
}

export function emptyArray(array) {
    return (typeof array === "undefined" || array === null || array.length === null || array.length === 0)
}

export function getUnitDatas(metricCode) {
    //return new Promise((resolve) => {
    //    return getMeasures().then((measures) => {
                if(measures)
                    return measures.find(x => x.code === metricCode)
    //    });
    //});
}

export async function convertUnit(productDatas, attributeCode) {
    const attribute = productDatas.values[attributeCode];
    let unitType = store.state.settings.unitType;


    let attributeDetails = await getAttributeDetails(attributeCode);
    //console.log(attributeDetails)
    let attributeDatas = {};
    attributeDatas.code = attributeCode;
    attributeDatas.label = attributeDetails.label;
    attributeDatas.drawingCode = attributeDetails.drawing_code;

    // Si c'est un objet on sait que la valeur est associé a une unité de mesure, donc on peut aller la récupérer
    if(_.isObject(attribute)){
        attributeDatas.value = await getMeasures().then((measures) => {
            if(measures){
                if(unitType === 'imperial'){
                    let imperialMeasureEquivalent = ImperialMeasureEquivalence(attribute.unit);
                    if(imperialMeasureEquivalent){
                        let measure = measures.find(x => x.code === imperialMeasureEquivalent)

                        if(measure){
                            let realAmount = convertAmount(attribute.amount, measure);
                            realAmount = formatDisplayAmount(realAmount);
                            return realAmount+' '+cleanSymbol(measure.symbol);
                        }
                    }
                }

                // METRIC OR UNKNOW IMPERIAL EQUIVALENCE FALLBACK
                let measure = measures.find(x => x.code === attribute.unit)
                if(measure){
                    return formatDisplayAmount(attribute.amount)+' '+cleanSymbol(measure.symbol)
                }
            }
        });
    }
    else {
        if(attribute){
            // Dans le cas d'un select on va chercher le label de la valeur en fonction de la liste des options disponibles
            if(attributeDetails.type === 'pim_catalog_simpleselect'){
                let valueDetails = attributeDetails.options.find(option => option.code === attribute);
                if(valueDetails)
                    attributeDatas.value = valueDetails.label;
            }
            // Si ce n'est pas un select on va regarder si l'unité n'est pas une unité non présente dans Akeneo, afin de lui attribuer une unité "en dur"
            else {
                let missingUnits = require('@/common/utils/missing_units.json');
                let missingUnit = missingUnits.find(x => x.code === attributeCode);
                if(missingUnit)
                    attributeDatas.value = formatDisplayAmount(attribute)+(missingUnit ? ' '+missingUnit[unitType] : '');
            }
        }
    }

    return attributeDatas;
}

export function getAttributeDetails(attributeCode) {
    return attributeService.show(attributeCode, {
        locale: store.state.settings.locale
    })
    .then((response) => {
        return response.data.data;
    })
}

export function convertAmount(value, measure, reverse = false) {
    if(reverse){
        if(measure.convert.mul)
            value = (value*measure.convert.mul)
        if(measure.convert.div)
            value = (value/measure.convert.div)
    }
    else{
        if(measure.convert.mul)
            value = (value/measure.convert.mul)
        if(measure.convert.div)
            value = (value*measure.convert.div)
    }
    value = _.round(value, 3);
    return value
}

export function cleanSymbol(symbol) {
    //@todo à modifier par la suite
    //switch (symbol) {
    //    case 'KILOGRAM' :
    //        return 'kg'
//
    //    case 'METER' :
    //        return 'm'
//
    //    case 'KILOWATT' :
    //        return 'kw'
//
    //    case 'METER_PER_SECOND' :
    //        return 'm/s'
//
    //}

    return _.replace(symbol, /div/g, '/')
}

export function getMeasures() {
    return measures

    //return new Promise((resolve) => {
    //    if(store.state.settings.measures && store.state.settings.measuresFetchDate+86400000 > Date.now()) // 24h
    //        resolve(store.state.settings.measures);
    //    else
    //        resolve(store.dispatch('settings/fetchMeasures'));
    //});
}

export function formatDisplayAmount(amount) {
    amount = String(amount);
    var regex = /^\d*(?:\.[0-9]{0,4})+$/;
    if(regex.test(amount)){
        let displayAmount = _.trimEnd(amount, '0')
        displayAmount = _.trimEnd(displayAmount, '.')
        displayAmount = _.replace(displayAmount, '.', ',');
        return displayAmount;
    }
    else{
        return amount;
    }
}

export function objectFlip(obj) {
    const ret = {};
    Object.keys(obj).forEach((key) => {
        ret[obj[key]] = key;
    });
    return ret;
}

export function ImperialMeasureEquivalence(code, reverse = false) {
    let equivalences = {
        'METER': 'FEET',
        'MILLIMETER': 'INCH',
        'KILOMETER': 'MIL',
        'METER_PER_SECOND': 'FOOT_PER_SECOND',
        'KILOMETER_PER_HOUR': 'MILE_PER_HOUR',
        'CUBIC_METER': 'CUBIC_FOOT',
        'CUBIC_CENTIMETER': 'CUBIC_INCH',
        'LITER': 'GALLON',
        'KILOGRAM': 'POUND',
        'BAR': 'PSI',
    }

    if(reverse)
        equivalences = objectFlip(equivalences);

    /*if(equivalences[code] === undefined)
        console.log("Measure equivalence not found : ", code);*/

    return equivalences[code];
}

export async function convertFiltersValuesBackToMetric(filters) {
    let unitType = store.state.settings.unitType;

    if(unitType === 'imperial'){
        let newFilters = [];
        let measures = await getMeasures();

        for(let filterIndex = 0; filterIndex < filters.length; filterIndex++){
            let filter = filters[filterIndex];
            if(filter.type === 'slider'){
                let imperialMeasureEquivalent = ImperialMeasureEquivalence(filter.unit_code, true);
                if(imperialMeasureEquivalent){
                    let measure = measures.find(x => x.code === filter.unit_code)
                    filter.minValue = convertAmount(filter.minValue, measure, true);
                    filter.maxValue = convertAmount(filter.maxValue, measure, true);
                    filter.unit_code = imperialMeasureEquivalent;
                    newFilters.push(filter);
                    continue;
                }
            }
            // ALREADY METRIC (NO EQUIVALENCE FALLBACK)
            newFilters.push(filter);
        }
        return newFilters;
    }
    else {
        return filters;
    }
}

export async function convertFiltersArray(filters){
    let newFilters = [];

    for(let filterIndex = 0; filterIndex < filters.length; filterIndex++){
        let filter = filters[filterIndex];
        filter.val={'min':filter.minValue,'max':filter.maxValue}
        newFilters.push(filter);
    }

    return newFilters
}

export async function toggleBodyClass(addRemoveClass, className) {
    const el = document.body;

    if (addRemoveClass === 'addClass') {
        el.classList.add(className);
    } else {
        el.classList.remove(className);
    }
}

export async function downloadBlobFilename(filename, blob) {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
}

export function slugify(string) {
    const a = 'àáäâãåăæçèéëêǵḧìíïîḿńǹñòóöôœøṕŕßśșțùúüûǘẃẍÿź·/_,:;'
    const b = 'aaaaaaaaceeeeghiiiimnnnooooooprssstuuuuuwxyz------'
    const p = new RegExp(a.split('').join('|'), 'g')
    return string.toString().toLowerCase()
        .replace(/\s+/g, '-') // Replace spaces with -
        .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
        .replace(/&/g, '-and-') // Replace & with ‘and’
        .replace(/[^\w\-]+/g, '') // Remove all non-word characters
        .replace(/\-\-+/g, '-') // Replace multiple - with single -
        .replace(/^-+/, '') // Trim - from start of text
        .replace(/-+$/, '') // Trim - from end of text
}

export function localeToKebabCase(locale) {
    return _.replace(locale, /_/g, '-')
}

export function buildUrl(url, params) {
    let fullUrl = url;
    if(params)
        fullUrl = fullUrl+'?'+Object.keys(params).reduce((prev, key, i) => (
            `${prev}${i!==0?'&':''}${key}=${params[key]}`
        ), '');
    return fullUrl;
}

const currentEnv = process.env.VUE_APP_ENV;
const targetEnv = 'production';
export function triggerTrackingEvent(event, category, label, value = null) {
    let params = {}
    if (event === 'document_download') {
        params = {
            'document_type': category,
            'document_label': label,
        }
    } else if (event === 'search') {
        params = {
            'search_term': category,
            'search_product_selected': label,
        }
    } else if (event === 'calculator_tool') {
        params = {
            'calculator_machine': category,
            'calculator_mast': label,
        }
    } else if (event === 'feedback') {
        params = {
            'user_type': category,
            'feedback_label': label,
        }
    } else if (event === 'user_role') {
        params = {
            'user_type': category
        }
    } else {
        params = {
            'event_category': category,
            'event_label': label,
        }
    }
    if (value) params.value = value

    console.log('Even GA4 : ', event, params)
    if (targetEnv === currentEnv) gtag('event', event, params);
}